import { render, staticRenderFns } from "./VelocityGroup.vue?vue&type=template&id=a98fdb38&"
import script from "./VelocityGroup.vue?vue&type=script&lang=ts&"
export * from "./VelocityGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports